import { render } from "./EditDelete.vue?vue&type=template&id=02a775c6"
import script from "./EditDelete.vue?vue&type=script&lang=js"
export * from "./EditDelete.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__